import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
import { auth } from "@/lib/firebase";

// Firebase returns machine-readable codes; the UI shows these instead.
const ERROR_MESSAGES = {
  "auth/email-already-in-use": "Ese email ya tiene una cuenta. Inicia sesión.",
  "auth/invalid-email": "El email no es válido.",
  "auth/weak-password": "La contraseña debe tener al menos 6 caracteres.",
  "auth/user-not-found": "No hay ninguna cuenta con ese email.",
  "auth/wrong-password": "Contraseña incorrecta.",
  // Modern Firebase collapses wrong-password and user-not-found into this one
  // so an attacker cannot tell which emails are registered.
  "auth/invalid-credential": "Email o contraseña incorrectos.",
  "auth/too-many-requests": "Demasiados intentos. Espera unos minutos.",
  "auth/network-request-failed": "Sin conexión. Comprueba tu internet.",
  "auth/missing-password": "Escribe tu contraseña.",
};

function toMessage(error) {
  return ERROR_MESSAGES[error?.code] || "Algo ha ido mal. Inténtalo de nuevo.";
}

export async function registerUser(email, password) {
  try {
    const normalized = email.trim().toLowerCase();
    const { user } = await createUserWithEmailAndPassword(auth, normalized, password);
    await updateProfile(user, { displayName: normalized.split("@")[0] });
    // Best-effort: a failed verification email must not block the sign-up.
    sendEmailVerification(user).catch(() => {});
    return { success: true, user };
  } catch (error) {
    return { success: false, error: toMessage(error) };
  }
}

export async function loginUser(email, password) {
  try {
    const { user } = await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
    return { success: true, user };
  } catch (error) {
    return { success: false, error: toMessage(error) };
  }
}

export async function logoutUser() {
  await signOut(auth);
}

export async function resetPassword(email) {
  try {
    await sendPasswordResetEmail(auth, email.trim().toLowerCase());
    return { success: true };
  } catch (error) {
    return { success: false, error: toMessage(error) };
  }
}

export async function updateUserDisplayName(displayName) {
  if (!auth.currentUser) return { success: false, error: "No has iniciado sesión." };
  try {
    await updateProfile(auth.currentUser, { displayName });
    return { success: true };
  } catch (error) {
    return { success: false, error: toMessage(error) };
  }
}

export async function resendVerification() {
  if (!auth.currentUser) return { success: false, error: "No has iniciado sesión." };
  try {
    await sendEmailVerification(auth.currentUser);
    return { success: true };
  } catch (error) {
    return { success: false, error: toMessage(error) };
  }
}
